angular.module('app.directives').directive('vpSimpleFilter', ($rootScope) => ({
    restrict: 'EA',

    scope: {
        filter: '=model',
        noCard: '@?',
    },

    controller($scope) {
        $scope.useCard = $rootScope.isParamFalse($scope.noCard);

        $scope.fillUsing = (name) => {
            $scope.filter.fillUsing(name);
        };

        $scope.clear = (name) => {
            delete $scope.filterStorage[name];
        };

        $scope.filterStorage = $scope.filter.getStorage();
        $scope.$watch(
            'filterStorage',
            (newValue) => {
                $scope.filterList = newValue[`filter_${$scope.filter.name}`] || {};
            },
            true
        );
    },

    templateUrl: '/directives/filter/simple.html',
    transclude: false,
}));

angular.module('app.directives').directive('vpSimpleFilterLoading', () => ({
    restrict: 'A',

    scope: {
        filter: '<vpSimpleFilterLoading',
    },

    link(scope, element, attrs) {
        const e = angular.element(element);

        scope.$watch('filter.loading', (value) => {
            if (value) {
                e.addClass('vp-simple-filter-loading');
            } else {
                e.removeClass('vp-simple-filter-loading');
            }
        });
    },
}));

angular.module('app.directives').directive('vpSimpleFilterBanner', () => ({
    restrict: 'E',

    scope: {
        filter: '<model',
    },

    templateUrl: '/directives/filter/simple-banner.html',
}));
